import { createRoot } from "react-dom/client";
import axios from "axios";
import React from "react";
import { Chart, registerables } from "chart.js";
// Apps
import { MetronicI18nProvider } from "./app/i18n/Metronici18n";
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 * */
import "./app/assets/css/main.scss";
import { AppRoutes } from "./app/routing/AppRoutes";
import AuthProvider from "./app/utils/useAuth";
import { StartupProvider } from "./app/utils/useStartup";
import { getAuth } from "./app/utils/AuthHelpers";
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */

function setupAxios() {
    // @ts-ignore
    axios.defaults.headers.Accept = "application/json";
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    axios.interceptors.request.use(
        (config) => {
            const auth = getAuth();
            if (auth && auth.token) {
                // @ts-ignore
                config.headers.Authorization = `Bearer ${auth.token}`;
            }

            return config;
        },
        (err: any) => Promise.reject(err)
    );
    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        (err: any) => {
            return Promise.reject(err);
        }
    );
}
setupAxios();

Chart.register(...registerables);

const container = document.getElementById("root");

if (container) {
    createRoot(container).render(
        <MetronicI18nProvider>
            <AuthProvider>
                <StartupProvider>
                    <AppRoutes />
                </StartupProvider>
            </AuthProvider>
        </MetronicI18nProvider>
    );
}
